import { PageRequest } from './page-request';

export class PortalErrorEvent {
  public static EVENT_NAME: string = 'PortalErrorEvent';

  constructor(public pageRequest: PageRequest, public errorMessage: string) {}
}
